import { CurrencyInput } from '@/modules/localization/formatter';
import './home.scss';
export default function HomePage() {


  return (
    <>

      {/* <img src={logo} className="logo" />*/}
      <img src="/custom/home.png" />

    </>
  )
}
